"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interactiveRowStyles = exports.listItemStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const listItemSizeTokens = {
    medium: {
        '--list-item-size': 'var(--size-40)',
        '--list-item-gap': 'var(--space-2)',
        '--list-item-font-size': 'var(--font-size-24)',
        '--list-item-label-leading': 'calc(var(--font-line-height-24) - var(--font-size-14))',
    },
    large: {
        '--list-item-size': 'var(--size-80)',
        '--list-item-gap': 'var(--space-3)',
        '--list-item-font-size': 'var(--font-size-24)',
        '--list-item-label-leading': 'calc(var(--font-line-height-28) - var(--font-size-18))',
        '--list-item-description-leading': 'calc(var(--font-line-height-24) - var(--font-size-14))',
    },
};
exports.listItemStyles = (0, lit_1.css) `
  :host {
    display: flex;
    align-items: center;
    min-height: var(--list-item-size);
    gap: var(--list-item-gap);

    --list-item-size: var(--size-32);
    --list-item-gap: var(--space-2);
    --list-item-font-size: var(--font-size-14);
    --list-item-label-leading: calc(var(--font-line-height-24) - var(--font-size-14));
    --list-item-description-leading: calc(var(--font-line-height-16) - var(--font-size-12));
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', listItemSizeTokens))}

  [slot='leading'],
  [slot='trailing'] {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    min-height: var(--list-item-size);
    flex: 1;
  }

  /* label과 description의 행간이 다르면 글자 묶음이 넓은 쪽으로 치우친다.
     각 행간의 절반이 글자 위아래에 실리므로, 차이의 절반만큼 되밀어 시각 중심을 맞춘다. */
  :host([has-description]) .content {
    translate: 0 calc((var(--list-item-label-leading) - var(--list-item-description-leading)) / -4);
  }

  /* 이모지는 avatar 안의 글리프이며, 크기는 행 사이즈가 정한다. */
  .emoji {
    font-size: var(--list-item-font-size);
    line-height: 1;
  }
`;
/**
 * list-item 행을 감싸 눌리는 요소(button·a·role 있는 행)에 얹는 상호작용 스킨.
 * 행의 의미(role·이벤트)는 감싸는 컴포넌트가 소유하고, 여기서는 hover·포커스·선택·비활성 표시만 맡는다.
 */
exports.interactiveRowStyles = (0, lit_1.css) `
  :host {
    --interactive-row-background-color: transparent;
    --interactive-row-padding-inline: 0;
  }

  ${shared_styles_1.interactiveElement} {
    display: flex;
    align-items: center;
    width: 100%;
    padding-inline: var(--interactive-row-padding-inline);
    border-radius: var(--radius);
    color: inherit;
    box-sizing: border-box;
    cursor: pointer;
    ${shared_styles_1.layerContainerStyles};

    /* background state */
    &::before {
      border-radius: var(--radius);
      background-color: var(--interactive-row-background-color);
      ${shared_styles_1.backgroundLayerStyles};
    }

    &:hover {
      --interactive-row-background-color: var(--interaction-hover-background-color);
    }

    &:focus-visible {
      outline: var(--interaction-focus-outline);
      outline-offset: -1px;
    }

    &[aria-current='page'] {
      --interactive-row-background-color: var(--interaction-selected-background-color);
    }

    &[aria-selected='true'] {
      --interactive-row-background-color: var(--interaction-selected-background-color);
      color: var(--interaction-selected-foreground-color);
    }

    &[disabled],
    &[aria-disabled='true'] {
      ${shared_styles_1.disabledStyles};
      pointer-events: none;
    }
  }

  mm-list-item {
    flex: 1;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC1pdGVtLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxpc3QtaXRlbS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBSXBDLCtEQUtvQztBQUNwQyxtQ0FBbUU7QUFFbkUsTUFBTSxrQkFBa0IsR0FBb0Q7SUFDMUUsTUFBTSxFQUFFO1FBQ04sa0JBQWtCLEVBQUUsZ0JBQWdCO1FBQ3BDLGlCQUFpQixFQUFFLGdCQUFnQjtRQUNuQyx1QkFBdUIsRUFBRSxxQkFBcUI7UUFDOUMsMkJBQTJCLEVBQUUsd0RBQXdEO0tBQ3RGO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsa0JBQWtCLEVBQUUsZ0JBQWdCO1FBQ3BDLGlCQUFpQixFQUFFLGdCQUFnQjtRQUNuQyx1QkFBdUIsRUFBRSxxQkFBcUI7UUFDOUMsMkJBQTJCLEVBQUUsd0RBQXdEO1FBQ3JGLGlDQUFpQyxFQUFFLHdEQUF3RDtLQUM1RjtDQUNGLENBQUE7QUFFWSxRQUFBLGNBQWMsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7SUFjN0IsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxNQUFNLEVBQUUsa0JBQWtCLENBQUMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E2QjdELENBQUE7QUFFRDs7O0dBR0c7QUFDVSxRQUFBLG9CQUFvQixHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7SUFNbkMsa0NBQWtCOzs7Ozs7Ozs7TUFTaEIsb0NBQW9COzs7Ozs7UUFNbEIscUNBQXFCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztRQXVCckIsOEJBQWM7Ozs7Ozs7O0NBUXJCLENBQUEifQ==